import { getAdId } from 'Selectors';
import { getActivePageLayout } from 'PreviewSelectors';
import { APP, PRESENT, PREVIEW, LAYOUTS_PATH } from 'SharedConstants/';
import saveStatuses from 'PreviewConfig/saveStatuses';

export const createLayout = (key, id, name, background, backgroundFileName, backgroundDimensions) => ({
  type: 'CREATE_LAYOUT',
  key,
  id,
  name,
  background,
  backgroundFileName,
  backgroundDimensions,
});

export const createCustomLayout = () => (dispatch, getState) => {
  const state = getState();
  const adId = getAdId(state);

  const layouts = state.getIn([...LAYOUTS_PATH]);
  const layoutKeys = layouts.map(layout => layout.key).toIndexedSeq().toArray();
  const incrementedKey = layoutKeys.length ? (Math.max(...layoutKeys) + 1).toString() : '1';

  const requestBody = {};
  requestBody.layout = { key: incrementedKey };

  const settingsPanel = document.getElementById('previewSettings');
  $(settingsPanel).portlet({ refresh: true });

  fetch(`/build/ads/${adId}/create_preview`, // eslint-disable-line no-undef
    {
      method: 'PUT',
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content, // eslint-disable-line no-undef
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify(requestBody),
    }).then(response => response.json()).then((layout) => {
    setTimeout(() => { $(settingsPanel).portlet({ refresh: false }); }, 500);
    dispatch(createLayout(incrementedKey, layout.id, layout.name, layout.background, layout.backgroundFileName, layout.backgroundDimensions));
  });
};

export const customPreviewArtboardsLoaded = () => ({
  type: 'CUSTOM_PREVIEW_ARTBOARDS_LOADED',
});

export const loadDuplicatedLayout = (incrementedKey, layout) => ({
  type: 'LOAD_DUPLICATED_LAYOUT',
  incrementedKey,
  layout,
});

export const duplicateCustomLayout = () => (dispatch, getState) => {
  const state = getState();
  const adId = getAdId(state);

  const layouts = state.getIn([...LAYOUTS_PATH]);
  const layoutKeys = layouts.map(layout => layout.key).toIndexedSeq().toArray();
  const incrementedKey = layoutKeys.length ? (Math.max(...layoutKeys) + 1).toString() : '1';
  const layout = getActivePageLayout(state);

  const settingsPanel = document.getElementById('previewSettings');
  $(settingsPanel).portlet({ refresh: true });

  const requestBody = {};
  requestBody.layout = { key: incrementedKey, id: layout.id };

  fetch(`/build/ads/${adId}/duplicate_preview`, // eslint-disable-line no-undef
    {
      method: 'PUT',
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content, // eslint-disable-line no-undef
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify(requestBody),
    }).then(response => response.json()).then((duplicateddLayout) => {
    setTimeout(() => { $(settingsPanel).portlet({ refresh: false }); }, 500);
    dispatch(loadDuplicatedLayout(incrementedKey, duplicateddLayout));
  });
};

export const updateLayoutBackground = (layout, background, backgroundFileName, backgroundDimensions) => ({
  type: 'UPDATE_LAYOUT_BACKGROUND',
  layout,
  background,
  backgroundFileName,
  backgroundDimensions,
});

export const updateLayoutBackgroundOpacity = value => ({
  type: 'UPDATE_LAYOUT_BACKGROUND_OPACITY',
  value,
});

export const setBackgroundUploading = () => ({
  type: 'SET_BACKGROUND_UPLOADING',
});

export const addLayoutBacgkround = files => (dispatch, getState) => {
  const state = getState();
  const adId = getAdId(state);
  const layout = getActivePageLayout(state);
  const background = files[0];

  const data = {};
  data.layout = {};
  data.layout.id = layout.id;

  const reader = new FileReader(); // eslint-disable-line no-undef

  reader.addEventListener('load', () => {
    const src = reader.result;
    if (src.includes('data:image')) {
      const img = new Image(); // eslint-disable-line no-undef
      img.onload = () => {
        const isRetina = background.name.includes('@2x.');
        const backgroundWidth = isRetina ? (img.width / 2) : img.width;
        const backgroundHeight = isRetina ? (img.height / 2) : img.height;

        data.layout.background_file_name = background.name;
        data.layout.background = reader.result;
        data.layout.background_dimensions = [backgroundWidth, backgroundHeight];

        dispatch(setBackgroundUploading());

        fetch(`/build/ads/${adId}/layout_background`, // eslint-disable-line no-undef
          {
            method: 'PUT',
            headers: {
              'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content, // eslint-disable-line no-undef
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify(data),
          }).then(response => response.json()).then((backgroundImage) => {
          dispatch(updateLayoutBackground(layout, backgroundImage.url, backgroundImage.file_name, [backgroundWidth, backgroundHeight]));
        });
      };
      img.src = src;
    }
  });
  reader.readAsDataURL(background);
};

export const saveLayout = () => (dispatch, getState) => {
  const state = getState();
  const adId = getAdId(state);

  const saveStatus = state.getIn(['ui', 'saveStatus']);
  if (saveStatus === saveStatuses.saving) {
    dispatch({ type: 'SAVING_STILL' });
    return;
  }
  if (saveStatus !== saveStatuses.saveReady) return;
  dispatch({ type: 'SAVING' });

  const layout = getActivePageLayout(state);
  const preview = state.getIn([APP, PRESENT, PREVIEW]);
  const adStateContainers = layout.getAdStateContainers(preview);

  const data = {};
  data.layout = {};
  data.layout.id = layout.id;
  data.layout.name = layout.name;
  data.layout.device = layout.device;
  data.layout.background_options = JSON.stringify({
    in_app: layout.inApp,
    device_header: layout.deviceHeader,
    dimensions: [layout.backgroundDimensions.get(0), layout.backgroundDimensions.get(1)],
    alignment: layout.backgroundAlign,
    opacity: layout.backgroundOpacity,
    monochrome: layout.backgroundMonochrome,
  });

  const layoutContainers = {};
  adStateContainers.map((container, index) => {
    layoutContainers[index] = {};
    layoutContainers[index].artboard = container.artboard;
    layoutContainers[index].dimensions = [];
    container.dimensions.map((value, i) => layoutContainers[index].dimensions[i] = value);
    layoutContainers[index].isFixed = container.isFixed;
  });

  data.layout.adstate_containers = JSON.stringify(layoutContainers);

  fetch(`/build/ads/${adId}/preview`, // eslint-disable-line no-undef
    {
      method: 'PUT',
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content, // eslint-disable-line no-undef
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify(data),
    })
    .then(() => {
      setTimeout(() => dispatch({ type: 'SAVE_SUCCESS' }), 2000);
      setTimeout(() => dispatch({ type: 'SAVE_COMPLETED' }), 3500);
    })
    .catch(() => {
      setTimeout(() => dispatch({ type: 'SAVE_ERROR' }), 2000);
      setTimeout(() => dispatch({ type: 'SAVE_COMPLETED' }), 3500);
    });
};

export const handleDeleteLayout = layout => ({
  type: 'DELETE_LAYOUT',
  layout,
});

export const deleteLayout = () => (dispatch, getState) => {
  const state = getState();
  const adId = getAdId(state);
  const layout = getActivePageLayout(state);

  const settingsPanel = document.getElementById('previewSettings');
  $(settingsPanel).portlet({ refresh: true });

  const data = {};
  data.layout = {};
  data.layout.id = layout.id;

  fetch(`/build/ads/${adId}/preview`, // eslint-disable-line no-undef
    {
      method: 'delete',
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content, // eslint-disable-line no-undef
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify(data),
    }).then((response) => {
    setTimeout(() => { $(settingsPanel).portlet({ refresh: false }); }, 500);
    if (response.ok) dispatch(handleDeleteLayout(layout));
  });
};

export const updateCustomLayoutName = name => ({
  type: 'UPDATE_SELECTED_CUSTOM_LAYOUT_NAME',
  name,
});

export const updatCustomLayoutDevice = device => ({
  type: 'UPDATE_SELECTED_CUSTOM_LAYOUT_DEVICE',
  device,
});

export const toggleLayoutInApp = () => ({
  type: 'TOGGLE_LAYOUT_IN_APP',
});

export const updateLayoutDeviceHeader = value => ({
  type: 'UPDATE_LAYOUT_DEVICE_HEADER',
  value,
});

export const toggleLayoutBackgroundMonochrome = () => ({
  type: 'TOGGLE_LAYOUT_BACKGROUND_MONOCHROME',
});

export const selectAdStateContainer = adStateContainerKey => ({
  type: 'SELECT_ADSTATE_CONTAINER',
  adStateContainerKey,
});

export const deselectAdStateContainers = () => ({
  type: 'DESELECT_ADSTATE_CONTAINER',
});

export const updateAdStateContainerArtboard = (adContainerKey, selectedArtboard) => ({
  type: 'UPDATE_ADSTATE_CONTAINER_ARTBOARD',
  adContainerKey,
  selectedArtboard,
});

export const updateAdStateContainerPosition = (adContainerKey, position, value) => ({
  type: 'UPDATE_ADSTATE_CONTAINER_POSITION',
  adContainerKey,
  position,
  value,
});

export const updateAdStateContainerDimensions = (adContainerKey, dimension, value) => ({
  type: 'UPDATE_ADSTATE_CONTAINER_DIMENSIONS',
  adContainerKey,
  dimension,
  value,
});

export const updateAdStateContainerDragPosition = (adStateContainerKey, x, y) => ({
  type: 'UPDATE_ADSTATE_CONTAINER_DRAG_POSITION',
  adStateContainerKey,
  x,
  y,
});

export const toggleAdStateContainerIsFixed = adStateContainerKey => ({
  type: 'TOGGLE_ADSTATE_CONTAINER_ISFIXED',
  adStateContainerKey,
});

export const addNewAdStateContainer = () => ({
  type: 'ADD_NEW_ADSTATE_CONTAINER',
});

export const deleteAdStateContainer = adStateContainerKey => ({
  type: 'DELETE_ADSTATE_CONTAINER',
  adStateContainerKey,
});



// WEBPACK FOOTER //
// ./app/javascript/packs/App/Preview/actions/customLayoutActions.js